//TODO gui2
export class DynamicExpressionEditor {
    constructor() {
    }

    registerDynamicSelector(view, fieldId){

    }

    entityTypeChanged(id, value){

    }
}